// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/v-speeds.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/v-speeds/certification-v-speeds.js';
import g1 from '../lessons/aeronautics/v-speeds/v-speeds.js';

mount([g0, g1]);
